import React from 'react';
import { useLocation, Link as RouterLink } from 'react-router-dom';
import { useGetPageRoutingURL } from 'js/hooks/useGetPageRoutingURL';
import {
    isHashLink,
    getPartsUrl,
    getCleanUrl,
    isExternalUrl,
    getCombinedSearch,
    isDocumentsAndMediaUrl
} from 'js/utils/url.util';

import style from './Link.scss';

export const Link = ({ children, href = '', className = '', isDefaultLinkClass = true, inNewWindow = false, ...other }) => {
    const location = useLocation();
    const attribs = {
        href,
        className: `${isDefaultLinkClass ? style.link : ''} ${className}`,
        target: inNewWindow ? '_blank' : '_self',
        ...other
    };
    const linkPath = useGetPageRoutingURL(attribs.href);
    const isDocAndMediaUrl = isDocumentsAndMediaUrl(href);

    if (isDocAndMediaUrl) {
        const [, , , formattedPath] = getPartsUrl(href);

        attribs.href = getCleanUrl(formattedPath);
    }

    if (isExternalUrl(linkPath) || isHashLink(linkPath) || isDocAndMediaUrl) {
        return <a {...attribs}>{children}</a>;
    }

    const link = new window.URL(linkPath, document.baseURI);
    const to = {
        state: {
            prevPath: location.pathname
        },
        pathname: link.pathname,
        search: getCombinedSearch(link.search, location.search),
        hash: link.hash
    };

    return <RouterLink to={to} {...attribs}>{children}</RouterLink>;
};
